import { useCallback, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { HiArrowLeft, HiCalendar, HiMiniPencilSquare } from 'react-icons/hi2'
import { Link } from 'react-router-dom'

import { Select } from './Select'
import { ModalEvaluation360 } from './ModalEdit'
import Loading from '../Loading/Loading'
import Evaluation360 from '../../API/Evaluation/Evaluation360'
import { ListEmployee } from '../../Components/Evaluation360/ListEmployee'
import Lists from '../../API/Lists/Lists'

import countryMapper from '../../Utils/CountriesMapper.js'
import areasMapper from '../../Utils/AreasMapper.js'
import levelsMapper from '../../Utils/LevelsMapper.js'
import { evaluation360 } from '../../i18n/translatedMessages'
import { getEmployeesURL } from '../../API/Employee/Employee'

export function Evaluation() {
	const token = localStorage.getItem('token')
	const { id } = useParams()

	const [template, setTemplate] = useState(null)
	const [loading, setLoading] = useState(true)
	const [show, setShow] = useState(false)
	const [lists, setLists] = useState(null)

	const [employees, setEmployees] = useState(null)
	const [employeesFiltered, setEmployeesFiltered] = useState([])

	const [filter, setFilter] = useState({
		area: 0,
		country: 0,
		level: 0,
		name: '',
	})

	const loadData = useCallback(async () => {
		try {
			const company = JSON.parse(localStorage.getItem('user')).id
			const [responseEmployee, responseTemplate, areas, countries, levels] = await Promise.all([
				Evaluation360.getAllEmployeeByTemplate(id),
				Evaluation360.getOneTemplate(id),
				Lists.areas(),
				Lists.countries(),
				Lists.levels(),
			])

			const employeeImgs = await getEmployeesURL(company, token)

			const updatedEvaluations = responseEmployee.map(item => ({
				...item,
				profileImg: employeeImgs.find(img => img.mydnaUserEmail === item.targetEmail)?.url || null,
			}))

			setEmployees(updatedEvaluations)

			setLists({
				areas: areas.map(areasMapper.toDomain),
				countries: countries.map(countryMapper.toDomain).sort((a, b) => {
					if (a.value === 'Chile') return -1
					if (b.value === 'Chile') return 1
					return a.value.localeCompare(b.value)
				}),
				levels: levels.map(levelsMapper.toDomain),
			})

			setTemplate(responseTemplate)
		} catch (error) {
			console.error('ERROR - EVALUATION EMPLOYEE: ', error)
		} finally {
			setLoading(false)
		}
	}, [])

	useEffect(() => {
		loadData()
	}, [loadData])

	useEffect(() => {
		setEmployeesFiltered(employees)
	}, [employees])

	const handleFilterChange = event => {
		setFilter({
			...filter,
			[event.target.name]: event.target.value,
		})
	}

	useEffect(() => {
		if (filter.area === 0 && filter.country === 0 && filter.level === 0 && filter.name === '') {
			setEmployeesFiltered(employees)
			return
		}

		const filteredList = employees.filter(employee => {
			const areaMatch = filter.area === 0 || employee.targetArea.id === filter.area
			const countryMatch = filter.country === 0 || employee.targetCountry.id === filter.country
			const levelMatch = filter.level === 0 || employee.targetLevel.id === filter.level
			const nameMatch = filter.name === '' || employee.targetName.toLowerCase().includes(filter.name.toLowerCase())

			return areaMatch && countryMatch && levelMatch && nameMatch
		})

		setEmployeesFiltered(filteredList)
	}, [filter])

	const formateDate = isoDate => {
		const [year, month, day] = isoDate.split('T')[0].split('-')
		return `${day}/${month}/${year}`
	}

	const clean = () => {
		setFilter({
			area: 0,
			country: 0,
			level: 0,
			name: '',
		})
	}

	const calcDate = initDate => {
		const date = new Date()
		const initTemplate = new Date(initDate)
		if (date < initTemplate) {
			return <div className='tw-bg-alert-200 tw-text-alert-800 tw-rounded-full tw-w-32 tw-text-center tw-px-3 tw-py-1'>Programada</div>
		}
		return (
			<div className='tw-bg-green-200 tw-text-green-800 tw-rounded-full tw-w-32 tw-text-center tw-px-3 tw-py-1'>{evaluation360.labelFineshed}</div>
		)
	}

	if (loading) return <Loading />

	return (
		<div>
			<div className='tw-flex tw-items-center tw-justify-between tw-gap-4 tw-mr-4 tw-mb-5'>
				<div className='tw-flex tw-items-center tw-gap-4'>
					{
						<Link
							to='/app/services/evaluation/360'
							className='tw-bg-purple tw-text-white tw-w-8 tw-h-8 tw-rounded-full border border-0 tw-flex tw-justify-center tw-items-center'
						>
							<HiArrowLeft size={16} />
						</Link>
					}
					<h4 className='tw-m-0 tw-p-0 tw-font-bold tw-text-base'>{template.name}</h4>
					<div className='tw-m-0 tw-p-0 tw-flex tw-items-center tw-text-sm tw-text-gray-500'>
						<HiCalendar className='tw-mr-2' size={16} />
						{formateDate(template.initDate)} - {formateDate(template.endDate)}
					</div>
					{template.status === 'active' ? (
						<div className='tw-bg-blue-200 tw-text-blue-800 tw-rounded-full tw-w-32 tw-text-center tw-px-3 tw-py-1'>
							{evaluation360.labelProgress}
						</div>
					) : (
						calcDate(template.initDate)
					)}
				</div>

				<button
					className='tw-cursor-pointer tw-py-2 tw-px-3 tw-bg-purple tw-text-white border-0 tw-rounded-lg tw-flex tw-items-center tw-gap-3'
					onClick={() => setShow(true)}
				>
					<HiMiniPencilSquare />
					{evaluation360.btnEditParams}
				</button>
			</div>

			{lists && (
				<div className='tw-flex tw-gap-2 tw-items-center tw-h-[36px] tw-mb-5'>
					<input
						type='text'
						value={filter.name}
						className='tw-h-[32px] tw-w-2/6 border'
						placeholder='Buscar Colaborador'
						style={{ borderRadius: 6 }}
						onChange={handleFilterChange}
						name='name'
					/>
					<Select
						list={lists.countries}
						option={filter.country}
						onChange={handleFilterChange}
						placeholder='País'
						name='country'
						className='tw-w-1/6'
					/>
					<Select list={lists.areas} option={filter.area} onChange={handleFilterChange} placeholder='Area' name='area' className='tw-w-1/6' />
					<Select
						list={lists.levels}
						option={filter.level}
						onChange={handleFilterChange}
						placeholder='Nivel Jerarquico'
						name='level'
						className='tw-w-[200px]'
					/>
					<button onClick={clean} className='tw-h-[38px] tw-bg-white tw-w-1/6 border tw-rounded-md'>
						{evaluation360.btnCleanFilters}
					</button>
				</div>
			)}

			<div className='tw-mr-4 tw-h-[600px] tw-overflow-y-scroll tw-pr-4'>
				{employeesFiltered ? (
					<div>
						<ListEmployee employees={employeesFiltered} template={template} />
					</div>
				) : (
					<div className='tw-h-full tw-w-full tw-flex tw-items-center tw-justify-center border tw-bg-gray-100 tw-rounded-md tw-text-gray-600'>
						{evaluation360.labelThereAreNotEmployee}
					</div>
				)}
			</div>
			<ModalEvaluation360
				show={show}
				setShow={setShow}
				load={loadData}
				dataTemplate={{ ...template, employees: employees.map(item => item.targetEmployeeId) }}
			/>
		</div>
	)
}
